// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__35yzn","faq_title":"Faq_faq_title__34iZa","answer":"Faq_answer__8by0z","active":"Faq_active__2mdeJ"};